import { Web } from 'sip.js';

/**
 * Транспорт, который называет себя движку тем, чем он для движка и является.
 *
 * ⭐ Замерено, а не выведено (tel1f). Один и тот же REGISTER в один и тот же
 * адрес: с подписью `Via: SIP/2.0/WS` движок отвечает `401 Unauthorized`
 * (просит пароль — нормальное начало регистрации), с подписью `SIP/2.0/WSS` —
 * НЕ отвечает ничего. Проверено дважды: через nginx и напрямую в движок на
 * петлю, то есть nginx ни при чём.
 *
 * Почему так. Браузер приходит по `wss://`, и библиотека берёт подпись из
 * адреса — формально верно. Но TLS снимает nginx, и до движка соединение
 * доходит обычным `ws`; отвечать движок обязан по подписи из Via, а транспорта
 * «wss» у него нет вовсе (мы его сознательно не заводим — иначе второй
 * открытый порт и вторая копия сертификатов). Ответ становится
 * неотправляемым, и снаружи это выглядит как «сервер молчит на регистрацию»:
 * соединение живое, ошибок нет, регистрации нет.
 *
 * Подпись `WS` описывает ровно тот участок, который движок терминирует.
 * Защищённость от этого не меняется: до nginx всё так же TLS.
 *
 * Ловушка — sipTransport.test.ts: вернётся «WSS» — тест покраснеет.
 */
export class ProxiedWebSocketTransport extends Web.Transport {
  public get protocol(): string {
    return 'WS';
  }
}
